module.exports = __webpack_public_path__ + "img/sfdw.2188a956.png";